<template>
  <div class="custom-label">
    <bread-crumb></bread-crumb>
    <top-bar
      :isShowSelect="isShowSelect"
      placeholder="请选择"
      :data="businessList"
      :clickAddButton="clickAddButton"
      @selectChange="selectChange"
      :selectValues="selectValue"
      @getDefaultValue="getDefaultValue"
    ></top-bar>
    <base-table
      :tableData="tableData"
      v-if="tableData.tableList"
      @handleClick="handleClick"
    ></base-table>
    <pagination
      @sizePageChange="paginationChangeProduct"
      :paginationDatas="paginationDataProduct"
    >
    </pagination>
    <!-- 新增 -->
    <base-dialog
      :dialogShow="dialogShow"
      @dialogHandel="dialogHandel"
      :formData="formData"
      @changeSelectVal="changeSelectVal"
      @closeDialog="closeDialog"
    ></base-dialog>
    <!-- 编辑 -->
    <base-dialog
      :dialogShow="editDialogShow"
      @dialogHandel="editDialogHandel"
      :formData="formData"
      @changeSelectVal="editChangeSelectVal"
      @closeDialog="editCloseDialog"
      :isDisabled="isDisabled"
    ></base-dialog>
    <!-- 删除 -->
    <modal
      :isShow="deleteDialog"
      title="删除"
      :isShowBtn="isShowBtn"
      :btnText="btnText"
      @clickHandler="deleteClickHandler"
      @update:isShow="handleDialogLabel(false)"
    >
      <div class="dialogVal">确认删除</div>
    </modal>
  </div>
</template>

<script>
import topBar from "../../../../../components/topBar";
import baseTable from "../../../../../components/baseTable";
import breadCrumb from "../../../../../components/breadCrumb";
import baseDialog from "../../../components/baseDialog";
import pagination from "../../../../../components/pagination";
import {
  pageCategoriesByBusinessId,
  listContentBusinessForUserMan,
  saveOrUpdateContentCategory,
  deleteContentCategory,
} from "@/api/man";
import modal from "@/components/modal";

export default {
  name: "categoryManage",
  components: {
    baseTable,
    topBar,
    breadCrumb,
    baseDialog,
    pagination,
    modal,
  },
  data() {
    return {
      isShowSelect: true,
      businessList: [],
      dialogShow: false,
      formData: {
        formList: {
          title: "新增栏目",
          nameKey: "栏目名称",
          nameValue: "",
          belongInfo: "所属业务",
          business_ID: "", // 业务id
          infoKey: "备注",
          infoValue: "",
          inputPlaceholder: "不超过10个字的名称，多填写时不支持输入",
          textareaPlaceholder: "请输入申请理由",
          maxlength: "150",
          type: 1, //0(13\16) or 1(28)
        },
      },
      tableData: {
        tableList: [],
        tableHeader: [
          {
            label: "栏目ID",
            prop: "id",
          },
          {
            label: "栏目名称",
            prop: "name",
          },
          {
            label: "所属业务",
            prop: "contentBusinessName",
          },
          {
            label: "创建时间",
            prop: "createTime",
          },
          {
            label: "创建人",
            prop: "createUser",
          },
        ],
        tableType: 6,
      },
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      // business_ID: 1, // 业务id
      editDialogShow: false,
      deleteDialog: false,
      btnText: ["取消", "确认"],
      isShowBtn: [true, true, false],
      editValue: "", // 需要修改的信息
      deleteValue: "", // 需要删除的信息
      selectValue: "",
      isDisabled: true,
    };
  },
  created() {
    this.getDefaultValue();
    this.listContentBusinessForUserMan(); // 获取业务列表
  },
  mounted() {},
  watch: {
    "formData.formList.nameValue"(newValue, oldValue) {
      if (this.$utils.specialCharacters(newValue)) {
        this.$message({
          message: "禁止输入特殊字符",
          type: "warning",
        });
        this.formData.formList.nameValue = this.$utils.removalSpace(newValue);
      }
    },
  },
  methods: {
    async listContentBusinessForUserMan() {
      let res = await listContentBusinessForUserMan({
        tenantId: this.$commonJs.getTenantId(),
      }).then((res) => {
        this.businessList.splice(0, this.businessList.length);
        res?.contentBusinesses?.map((item) => {
          this.businessList.push({
            value: item.id,
            label: item.name,
          });
        });

        this.selectValue = this.businessList[0];
      });
    },
    selectChange(target) {
      this.formData.formList.business_ID = target;
      this.pageCategoriesByBusinessId();
    },
    clickAddButton() {
      this.formData.formList.nameValue = "";
      this.formData.formList.infoValue = "";
      this.formData.formList.belongValue = "";
      this.dialogShow = true;
    },
    //新增
    dialogHandel(data) {
      this.dialogShow = data;
    },
    //修改
    editDialogHandel(data) {
      this.editDialogShow = data;
    },
    getDefaultValue(data) {
      if (data) {
        this.formData.formList.business_ID = data.value;
        this.pageCategoriesByBusinessId(); // 获取业务对应的频道列表
      }
    },
    changeSelectVal(target) {
      this.selectValue = {
        value: target,
      };
      this.formData.formList.business_ID = target;
    },
    //-----------------------------------------------------------------待修改---------------------------------------
    editChangeSelectVal(target) {
      this.selectValue = {
        value: target,
      };
      this.formData.formList.business_ID = target;
    },
    closeDialog(type) {
      if (type === "success") {
        if (
          this.formData.formList.nameValue &&
          this.formData.formList.nameValue.trim() != "" &&
          this.formData.formList.business_ID
        ) {
          saveOrUpdateContentCategory({
            tenantId: this.$commonJs.getTenantId(),
            contentBusinessId: this.formData.formList.business_ID,
            name: this.formData.formList.nameValue,
            remark: this.formData.formList.infoValue,
            rangeType: this.formData.formList.publicity,
          })
            .then((res) => {
              if (res === 1) {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.dialogShow = false;
                this.pageCategoriesByBusinessId();
              }
            })
            .catch((res) => {
              if (res.data === 0) {
                this.$message.error("添加失败");
              } else if (res.data === -1) {
                this.$message.error("名称已存在");
              } else if (res.code === "0001") {
                this.$message.error(res.msg);
              }
            });
        } else if (!this.formData.formList.business_ID) {
          this.$message.error("请选择所属业务");
        } else {
          this.$message.error("请输入栏目名称");
        }
      } else if (type === "cancel") {
        this.dialogShow = false;
      }
    },
    editCloseDialog(type) {
      if (type === "success") {
        if (
          this.formData.formList.nameValue &&
          this.formData.formList.nameValue.trim() != ""
        ) {
          saveOrUpdateContentCategory({
            tenantId: this.$commonJs.getTenantId(),
            id: this.editValue.id,
            contentBusinessId: this.formData.formList.business_ID,
            name: this.formData.formList.nameValue,
            remark: this.formData.formList.infoValue,
          })
            .then((res) => {
              //
              if (res) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
                this.editDialogShow = false;
                this.pageCategoriesByBusinessId();
              }
            })
            .catch((res) => {
              if (res.data === 0) {
                this.$message.error(res.msg);
              } else if (res.data === -1) {
                this.$message.error(res.msg);
              }
            });
        } else {
          this.$message.error("请输入栏目名称");
        }
      } else if (type === "cancel") {
        this.editDialogShow = false;
      }
    },
    handleDialogLabel(val) {
      this.deleteDialog = val;
    },
    handleClick(val) {
      if (val.type === "edit") {
        this.editDialogShow = true;
        this.formData.formList.title = "修改业务";
        this.formData.formList.business_ID = val.val.id;
        //
        // sessionStorage.setItem('business_ID', this.business_ID)
        this.getEditVal(val.val);
        // 数据回显
        this.formData.formList.nameValue = val.val.name;
        this.formData.formList.infoValue = val.val.remark;
        this.formData.formList.business_ID = val.val.contentBusinessId;
      } else if (val.type === "goAdmin") {
        this.$router.push({
          path: `/categoryManage/channels`,
          query: {
            id: val.val.id,
          },
        });
      } else if (val.type === "delete") {
        this.getDeleteVal(val.val);
        this.deleteDialog = true;
      }
    },
    // 删除
    deleteClickHandler(val) {
      if (val === "one") {
        this.deleteDialog = false;
      } else if (val === "two") {
        //确认删除

        deleteContentCategory({
          tenantId: this.$commonJs.getTenantId(),
          id: this.deleteValue.id,
        })
          .then((res) => {
            if (res) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.deleteDialog = false;
              this.pageCategoriesByBusinessId();
            }
          })
          .catch((res) => {
            this.$message.error(res.msg);
          });
      }
    },
    showDialog() {
      // this.dialogShow=true
    },
    pageCategoriesByBusinessId() {
      pageCategoriesByBusinessId({
        tenantId: this.$commonJs.getTenantId(),
        contentBusinessId: this.formData.formList.business_ID,
        pageNo: this.paginationDataProduct.currentPage,
        pageSize: this.paginationDataProduct.pageSize,
      }).then((res) => {
        this.tableData.tableList.splice(0, this.tableData.tableList.length);
        res.data.map((item) => {
          this.tableData.tableList.push(item);
          this.paginationDataProduct.total = res.totalCount;
          this.paginationDataProduct.currentPage = res.pageNo;
          this.paginationDataProduct.pageSize = res.pageSize;
        });
      });
    },
    getEditVal(val) {
      this.editValue = val;
    },
    getDeleteVal(val) {
      this.deleteValue = val;
    },
    // 分页
    paginationChangeProduct(val) {
      this.paginationDataProduct = val;
      this.pageCategoriesByBusinessId();
    },
  },
};
</script>

<style scoped lang="scss">
:deep(.el-textarea__inner) {
  resize: none;
  overflow: hidden;
  overflow-y: auto;
  display: inline-block;
  margin-bottom: 45px;
  margin-right: 15px;
  /*padding: 0 0;*/
  /*min-height: 23px;*/
}

:deep(.el-dialog__body) {
  padding: 30px 26px 0px 26px !important;
}
</style>
